module.exports = __webpack_public_path__ + "img/sample.b1e617ac.jpg";